export const DeepCopy = <T>(obj: T): T =>
  JSON.parse(JSON.stringify(obj));
